export default {
      id: "calendar-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#calendar",
      toString: function () {
        return this.url;
      }
    }